import React, {Component} from 'react';
import loading from "../assets/images/icons/loading.gif";

import './LoadinScreen.css'
class LoadingScreen extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return(
            <div className="LoadingScreen">
                <div className={"loadingWraper"}>
                    <img src={loading} className="loadingImage" />
                    {this.props.children}
                </div>
            </div>
        )
    }
}
export default LoadingScreen;